// 引入模块
import axios from "axios"
import qs from 'qs'
import store from '../store/store'
// 是否允许跨域
axios.defaults.withCredentials = false;
// axios初始化：延迟时间，主路由地址
let instance = axios.create({
  baseURL: 'https://erp.api.dayufeng.cn',
  timeout: 10000,
});

// 设置拦截器
axios.interceptors.request.use(
  config => {
    if (store.state.token) {
      // console.log(store.state.token)
      // config.headers.token = `${store.state.token}`;
      // config['headers']['Authorization'] = AUTH_TOKEN
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  });
//响应拦截器
instance.interceptors.response.use(function (response) {
  //对响应数据做些事
  return response;
}, function (error) {
  //请求错误时做些事
  return Promise.reject(error);
});

// 是否销毁拦截器
// 1.给拦截器起个名称 var myInterceptors = instance.interceptors.requesst.use();
// 2.instance.interceptors.request.eject(myInterceptor);

// 请求成功的回调
function checkStatus (res) {
  //请求结束成功
  if (res.status === 200 || res.status === 304) {
    return res.data
  }
  return {
    code: 0,
    msg: res.data.message || res.statusText,
    data: res.statusText
  }
  return res
}
// 请求失败的回调
function checkCode (res) {
  if (res.code === 200) {
    throw new Error(res.message)
  }
  return res
}
//模块化导出
export default {
  get (url, params) {
    if (!url) return;
    return instance({
      method: 'get',
      url: url,
      params,
      timeout: 30000
    }).then(checkStatus).then(checkCode)
  },
  post (url, data) {
    if (!url) return;
    return instance({
      method: 'post',
      url: url,
      data: qs.stringify(data),
      timeout: 30000
    }).then(checkStatus).then(checkCode)
  },
  postFile (url, data) {
    if (!url) return;
    return instance({
      method: 'post',
      url: url,
      data
    }).then(checkStatus).then(checkCode)
  }
}


// WEBPACK FOOTER //
// ./src/utils/axios.js